import { IconButton } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Eye, EyeOff } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { ILogin } from "../../types/authTypes";
import { store } from "../../store/store";
import { loginUser } from "../../store/actions/authActions";
import { AuthFormState } from "../../store/slices/feature/tempSlice";
import OTPInput from "react-otp-input";
import OtpInput from "./OtpInput";

export default function Login() {
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const [showPasswordButton, setShowPasswordButton] = useState<boolean>(false);
  const auth = useAppSelector((state) => state.user.authStatus);
  const formState = useAppSelector((state) => state.temp.authFormState);
  const initialValues: ILogin = { email: "", password: "" };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .trim("Please remove leading and trailing whitespace")
      .strict(true)
      .required("Please enter the email.")
      .email("Please enter a valid email.")
      .matches(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        "Please enter a valid email"
      ),

    password: Yup.string()
      .trim("Please remove leading and trailing whitespace")
      .strict(true)
      .required("Password is required."),
  });

  // check auth
  useEffect(() => {
    if (auth) {
      Navigate("/dashboard");
      // dispatch spinner data call
      //   dispatch(getSpinnerData());
      //   dispatch(getLoggedInUserData());
    }
  }, [Navigate, dispatch, auth]);

  return (
    <>
      <div className="bg-gray-100 flex justify-center items-center h-screen">
        <div className="w-1/2 h-screen hidden lg:block">
          <img
            src="/login.jpg"
            alt="Placeholder Image"
            className="object-cover w-full h-full"
          />
        </div>

        <div className="lg:p-36 md:p-52 sm:20 p-8 w-full lg:w-1/2">
          {formState === AuthFormState.Fresh ? (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                console.log(values);
                store.dispatch(loginUser(values));
                // alert(JSON.stringify(values, null, 2));
                // actions.setSubmitting(false);
              }}
            >
              {(formikProps) => (
                <>
                  {console.log(formikProps)}
                  <Form className="">
                    <>
                      <h1 className="text-2xl font-semibold mb-4">Login</h1>
                      <div className="mb-4">
                        <label className="block text-gray-600">
                          Email<span>*</span>
                        </label>
                        <Field
                          type="email"
                          placeholder="Enter email"
                          id="email"
                          required
                          name="email"
                          autoFocus
                          //   disabled={formState === AuthFormState.OtpSent}
                          className="tpe-form-input"
                          autoComplete="off"
                        />
                        <ErrorMessage
                          component="div"
                          name="email"
                          className="input-error"
                        />
                      </div>
                      <div className="mb-4 relative">
                        <label className="block text-gray-600">
                          Password<span>*</span>
                        </label>
                        <Field
                          type={showPasswordButton ? "text" : "password"}
                          required
                          id="password"
                          name="password"
                          //   disabled={formState === AuthFormState.OtpSent}
                          placeholder="Enter password"
                          className="tpe-form-input"
                          autoComplete="off"
                        />
                        <span className="absolute right-2 top-7">
                          <IconButton
                            aria-label="show password"
                            // disabled={formState === AuthFormState.OtpSent}
                            onClick={() =>
                              setShowPasswordButton(!showPasswordButton)
                            }
                          >
                            {showPasswordButton ? (
                              <Eye size={20} />
                            ) : (
                              <EyeOff size={20} />
                            )}
                          </IconButton>
                        </span>
                        <ErrorMessage
                          component="div"
                          name="password"
                          className="input-error"
                        />
                      </div>
                      <div className="mb-4 flex items-center">
                        {/* <input
              type="checkbox"
              id="remember"
              name="remember"
              className="text-blue-500"
            />
            <label className="text-gray-600 ml-2">Remember Me</label> */}
                      </div>
                      {/* <div className="mb-6 text-blue-500">
            <a href="#" className="hover:underline">
              Forgot Password?
            </a>
          </div> */}

                      <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-md py-2 px-4 w-full"
                      >
                        Login
                      </button>
                    </>
                  </Form>
                </>
              )}
            </Formik>
          ) : (
            <OtpInput />
          )}
        </div>
      </div>
    </>
  );
}
